// extracted by mini-css-extract-plugin
export default {"newsletter":"Newsletter_newsletter__ONLBn","container":"Newsletter_container__eXbkM","row":"Newsletter_row__CFU6C","left":"Newsletter_left__QPM9n","right":"Newsletter_right__ucuh5"};